const currentYear = new Date().getFullYear();

const getSeoSystemWithVariables = (seoSystem, systemName, companyName) => {
  const newObject = {};

  Object.entries(seoSystem).forEach(([key, value]) => {
    if (typeof value !== 'string') {
      return;
    }

    let newValue = value;
    newValue = newValue.replaceAll(/{{systemName}}|{{sn}}/g, systemName);
    newValue = newValue.replaceAll(/{{companyName}}|{{cn}}/g, companyName);
    newValue = newValue.replaceAll(/{{year}}/g, currentYear);

    // Add | businesswith.xx
    if (key === 'metaTitle') {
      const bwSite = process.env.GATSBY_SITE_URL.split('//')[1];
      newValue += ` | ${bwSite}`;
    }

    newObject[key] = newValue;
  });

  return newObject;
};

export default function useGetSeoSystem(
  categoryData,
  categoryDefaultData,
  systemName,
  companyName
) {
  const { seoSystem } = categoryData;
  const { seoSystem: seoSystemDefault } = categoryDefaultData;

  const systemSeoToUse = seoSystem || seoSystemDefault;

  // Replace all variables within title and description
  const fixedSystemSeoObject = getSeoSystemWithVariables(
    systemSeoToUse,
    systemName,
    companyName
  );

  return fixedSystemSeoObject;
}
